import { apiUrl as ibokApiUrl, responseHandler } from './apiHelper';

export const apiUrl = (path) => ibokApiUrl(`v1/${path.replace(/^\/+/, '')}`);

export const callGet = (path) => {
  const url = apiUrl(path);

  return fetch(
    url,
    {
      credentials: 'same-origin',
    },
  ).then(responseHandler);
};

export const callPost = (path, body) => {
  const url = apiUrl(path);

  const parsedBody = JSON.stringify(body);

  return fetch(
    url,
    {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: parsedBody,
    },
  ).then(responseHandler);
};

export const createConversation = async (message, classified) => callPost(
  'conversations',
  {
    body: message,
    classifiedId: classified.id,
  },
);
